import { makeAutoObservable } from "mobx";
import { MailsTasksResponse, CreateMailsTaskInfo } from "../../../api/typings/Mails";
import { MailsTasksApi } from "../../../api/mails/MailsTasksApi";
import { getCreateMailTaskData } from "../../serializers/mailsSerializer";

export class MailsService {
  constructor() {
    makeAutoObservable(this);
  }

  createMailTask = async (data: CreateMailsTaskInfo): Promise<MailsTasksResponse> => {
    const createMailTaskData = await getCreateMailTaskData(data);
    return MailsTasksApi.createMailTask(createMailTaskData);
  };

  getMailTask = async (id: string): Promise<MailsTasksResponse> => {
    return MailsTasksApi.getMailTask(id);
  };
}
